const showHide = (el, shouldShow) => {
  if (shouldShow) {
    $(el).loadingCurtain('show');
  } else {
    $(el).loadingCurtain('hide');
  }
};

// Vue 3 directive API
export default {
  mounted(el, binding) {
    showHide(el, binding.value);
  },
  updated(el, binding) {
    showHide(el, binding.value);
  },
};
